<script>
	import lettersSmall from './letters-small.js';
	import lettersRegular from './letters.js';
	// import { debounce } from 'lodash';
	import fileDownload from 'js-file-download';
	import { slide } from 'svelte/transition';

	const quickText = [
		{text: "hi!", emoji: "🐵"},
		{text: "yes", emoji: "👍"},
		{text: "no", emoji: "👎"},
		{text: "huh?", emoji:"❓"},
		{text: "stop", emoji: "🛑"},
		{text: "um", emoji: "🙄"},
		{text: "love", emoji: "❤️"},
		{text: "party", emoji: "🎉"},
		{text: "Roo!", emoji: "🦘"},
		{text: "happy birthday", emoji: "🎂"}
	]
	let targetWidth;
	let targetHeight;
	let fontSize;
	let canvas2;
	let imageOverlay;
	let gif;
	let file;
	let rendering;
	let canShareGif;
	let dirty = true;
	let showOptions = false;
	let config = {
		text: "hi!",
		emoji: "🐵",
		font: "small",
		animation: "wiggle"
	}


	const textToMatrix = (text, font) => {
		const matrix = {cells: []};
		let maxR = 0;
		let maxC = 0;
		const lines = text.split("\n");
		lines.forEach( (line, l) => {
			let maxLineC = 0;
			let maxLineR = 0;
			const words = line.split(" ");
			words.forEach( (word, w) => {
				const letters = word.split("");
				letters.forEach( (letter, t) => {
					const letterLayout = font[letter.toLowerCase()];
					if (!letterLayout) return;

					let maxLetterC = 0;
					let maxLetterR = 0
					letterLayout.forEach( (letterRow, r) => {
						const [repeat, columns] = letterRow.split(":");
						for (let p=0; p<repeat; p++) {
							maxLetterR += 1;
							columns.split("").forEach( (letterCol, c) => {
								maxLetterC = Math.max(maxLetterC, c);
								if (letterCol === "x" ) 
									matrix.cells.push({
										r: maxR+maxLetterR,
										c: maxLineC+c,
										line: l, word: w, letter: t
									});
							});
						}
					});
					maxLineR = Math.max(maxLineR, maxLetterR);
					maxLineC += maxLetterC +
						(t < letters.length-1 ? 2 : 1);
				})
				if (w < words.length-1) maxLineC += 3;
			});
			maxR += maxLineR;
			maxC = Math.max(maxC, maxLineC);
			if (l < lines.length-1) maxR += 1;
		});
		matrix.rowCount = maxR;
		matrix.colCount = maxC;
		return matrix;
	}

	const getFontSize = (ctx, emoji, colCount, maxWidth, rowCount, maxHeight, max=144, min=24) => {
		let size = max;
		while (size > min) {
			ctx.font = size + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif';
			const charMetrics = ctx.measureText(emoji);
			const charSize = Math.max(
				charMetrics.width,
				charMetrics.actualBoundingBoxAscent// + charMetrics.actualBoundingBoxDescent
			)*1.2;
			const width = colCount*charSize+2.4*charSize;
			const height = rowCount*charSize+2.4*charSize;
			if (width > maxWidth || (height && height > maxHeight) && size-1 > min) {
				size--;
			} else {
				return size;
			}
		}
	}

	function share() {
		navigator.share({
			files: [file]
		})
		gtag('event', 'share', {
			'event_label': config.emoji +"|" + config.text.replace("\n", " ").substring(0, 100)
		});
	}

	function download() {
		fileDownload(file, 'image.gif');
		gtag('event', 'download', {
			'event_label': config.emoji +"|" + config.text.replace("\n", " ").substring(0, 100)
		});
	}

	function validator(node, value) {
		return {
			update(value) {
				file = null;
				imageOverlay.src = "";
				dirty = true;
			}
		}
	}

	function getWobble(charSize, seed=3) {
		const random = Math.random;

		let xWobble = 0
		let yWobble = 0
		let offsets = [-1, 0, 1]
		let wobbleMagnitude = Math.ceil(charSize/10)
		let offset = Math.round(offsets[Math.floor(random()*offsets.length)] * wobbleMagnitude)

		if (offset != 0) {
			if (Math.floor(random()*2) == 0) {
				xWobble = offset
			} else {
				yWobble = offset
			}
		}
		return [xWobble, yWobble]
	}

	function renderLarge() {
		rendering = true;

		let context = canvas2.getContext("2d");

		let emoji = config.emoji; // [...emojiInput][0] || "🐵";

		const letters = config.font === "small" ? lettersSmall : lettersRegular;
		const matrix = textToMatrix(config.text, letters);
		fontSize = getFontSize(context, emoji, matrix.colCount, 2100, matrix.rowCount, 1800, 144);

		context.font = fontSize + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif';
		context.textAlign = "left";

		const charMetrics = context.measureText(emoji);
		const charSize = Math.max(
			charMetrics.width,
			charMetrics.actualBoundingBoxAscent// + charMetrics.actualBoundingBoxDescent
		)*1.2;

		targetHeight = matrix.rowCount*charSize+2.4*charSize;
		targetWidth = matrix.colCount*charSize+2.4*charSize;
		canvas2.width = targetWidth;
		canvas2.height = targetHeight;

		context.clearRect(0, 0, targetWidth, targetHeight);
		context.fillStyle = "black";
		matrix.cells.forEach( cell => {
			const x = cell.c*charSize+1.2*charSize;
			const y = cell.r*charSize+1.2*charSize;
			context.fillText(emoji, x, y);
		});
		const dataUrl = canvas2.toDataURL();
	}


	function renderImage() {
		rendering = true;

		let context = canvas2.getContext("2d");

		let emoji = config.emoji; //[...emojiInput][0] || "🐵";

		const letters = config.font === "small" ? lettersSmall : lettersRegular;
		const matrix = textToMatrix(config.text, letters);
		fontSize = getFontSize(context, emoji, matrix.colCount, 640, null, null, 22);
	
		gtag('event', 'render', {
			'event_label': config.emoji +"|" + config.text.replace("\n", " ").substring(0, 100)
		});

		context.font = fontSize + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif';
		context.textAlign = "left";

		const charMetrics = context.measureText(emoji);
		const charSize = Math.max(
			charMetrics.width,
			charMetrics.actualBoundingBoxAscent// + charMetrics.actualBoundingBoxDescent
		)*1.2;

		targetHeight = matrix.rowCount*charSize+2.4*charSize;
		targetWidth = matrix.colCount*charSize+2.4*charSize;

		let wAdjust;
		let hAdjust;
		const scaledHeightAdj = Math.round( (9/16) * targetWidth - targetHeight);
		const scaledWidthAdj = Math.round( (16/9) * targetHeight - targetWidth );
		const squareHeightAdj = Math.round( targetWidth - targetHeight );
		const squareWidthAdj = Math.round( targetHeight - targetWidth );

		if (scaledHeightAdj > 0) hAdjust = scaledHeightAdj;
		if (squareHeightAdj > 0 && squareHeightAdj < hAdjust) hAdjust = squareHeightAdj;
		if (scaledWidthAdj > 0) wAdjust = scaledWidthAdj;
		if (squareWidthAdj > 0 && squareWidthAdj < wAdjust) wAdjust = squareWidthAdj;
		if (wAdjust && hAdjust &&  wAdjust < hAdjust)  hAdjust = 0;
		if (wAdjust && hAdjust && hAdjust < wAdjust) wAdjust = 0;
		
		if (!wAdjust) wAdjust = 0;
		if (!hAdjust) hAdjust = 0;

		targetWidth += wAdjust;
		targetHeight += hAdjust;

		canvas2.width = targetWidth;
		canvas2.height = targetHeight;

		gif = new GIF({
			workers: 2,
			quality: 10,
			transparent: 0x00FF00,
			width: targetWidth,
			height: targetHeight
		});

		gif.on('finished', function(blob) {
			rendering = false;
			dirty = false;
			imageOverlay.src = URL.createObjectURL(blob);
			file = new File([blob], "image.gif", {type: "image/gif"});
			canShareGif = (navigator.canShare && navigator.canShare({ files: [file] }));
		});

		let frameCount = 1;
		let delay = 200;
		let unusedCells = [];
		let usedCells = [];
		let cellsPerFrame;

		if (config.animation === "wiggle") 
			frameCount = 10;

		if (config.animation === "flash") 
			frameCount = 2;

		if (config.animation === "build") {
			frameCount = 7
			cellsPerFrame = Math.ceil(matrix.cells.length/(frameCount-1));
			unusedCells = [...matrix.cells];
		}

		for (let i=0; i<frameCount; i++) {

			context.clearRect(0, 0, targetWidth, targetHeight);

			context.fillStyle = "#00FF00";
			context.fillRect(0,0,targetWidth,targetHeight);
		
			context.fillStyle = "white";
			context.fillRect(Math.round(wAdjust/2),Math.round(hAdjust/2), Math.round(targetWidth-wAdjust+10),Math.round(targetHeight-hAdjust));

			context.font = fontSize + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif';
			context.fillStyle = "black";

			if (config.animation === "flash")
				delay = i === 0 ? 800 : 250;

			if (config.animation === "wiggle" || config.animation === "none" || (config.animation === "flash" && i === 0)) {
				let wobbles = {}
				matrix.cells.forEach( cell => {
					const pos = cell.line + ":" + cell.letter;
					let wobble = [0, 0];
					if (i > 0) wobble = 
						wobbles[pos] = wobbles[pos] || getWobble(charSize);
					const x = cell.c*charSize+(cell.c > 1 ? 1.2 : 1)*charSize+wobble[0] + wAdjust/2;
					const y = cell.r*charSize+(cell.r > 1 ? 1.2 : 1)*charSize+wobble[1] + hAdjust/2;
					context.fillText(emoji, x, y);
				})
			}

			if (config.animation === "build" && i <frameCount-1) {
				for (let j=0; j<cellsPerFrame; j++) {
					if (!unusedCells.length) continue;
					const randomCell = Math.floor(Math.random()*unusedCells.length);
					usedCells.push(unusedCells[randomCell]);
					unusedCells.splice(randomCell, 1);
				}
		
				usedCells.forEach( cell => {
					const x = cell.c*charSize+1.2*charSize + wAdjust/2;
					const y = cell.r*charSize+1.2*charSize + hAdjust/2;
					context.fillText(emoji, x, y);
				})

				if (i === frameCount-2) delay = 1000;
			}

			gif.addFrame(canvas2, {copy: true, delay});
		};

		gif.render();

	}

	function setConfig(index) {
		config = {...config, ...quickText[index]}
		const myModalEl = document.getElementById('quick-text');
		const modal = bootstrap.Modal.getInstance(myModalEl)
		modal.hide();
		renderImage();
	}


</script>

<div class="m-4">
	<div class="mb-3 text-muted text-center">
		<h1>
			<img src="owl.svg" alt="owl logo" style="width:1.5em; height: 1.5em;" />
		</h1>
		<h4>animate your words with emoji</h4>
	</div>

	<div class="mb-3">
		<div class="d-flex justify-content-between align-items-center">
			<div>
				<label for="text-input" class="form-label">Text</label>
			</div>
			<div>
				<button type="button" class="btn btn-link text-right" data-bs-toggle="modal" data-bs-target="#quick-text">choose</button>		
			</div>
		</div>
		<textarea id='text-input' disabled={rendering} bind:value={config.text} use:validator={config.text} class="form-control"></textarea>
	</div>
	<div class="mb-3">
		<label for="emoji-input" class="form-label">Emoji</label>
		<input id="emoji-input" disabled={rendering} bind:value={config.emoji} use:validator={config.emoji} class="form-control" />
	</div>
	{#if !showOptions}
	<div class="mb-3">
		<button class="btn btn-link ps-0" on:click="{ () => showOptions = true }">show options</button>
	</div>
	{/if}
	{#if showOptions}
	<div transition:slide>
		<div class="mb-3">
			<label for="emoji-input" class="form-label">Font</label>
			<select id="emoji-input" disabled={rendering} bind:value={config.font} use:validator={config.font} class="form-select">
				<option value="regular">Regular</option>
				<option value="small">Short</option>
			</select>
		</div>
		<div class="mb-3">
			<label for="emoji-input" class="form-label">Animation</label>
			<select id="emoji-input" disabled={rendering} bind:value={config.animation} use:validator={config.animation} class="form-select">
				<option value="none">None</option>
				<option value="wiggle">Wiggle</option>
				<option value="build">Build</option>
				<option value="flash">Flash</option>
			</select>
		</div>
	</div>
	{/if}
	{#if dirty}
	<div class="mb-3">
		<button on:click={renderImage} disabled={rendering || !config.emoji || !config.text} class="btn btn-primary w-100">
			{#if rendering}
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
				<span class="visually-hidden">Loading...</span>
				<span class="ms-2">Draw</span>
			{:else}
				Draw			
			{/if}
		</button>
	</div>
	{/if}
	{#if file}
		<div class="mb-3">
		{#if canShareGif}
			<button on:click={share} class="btn btn-success w-100" >Share</button>
		{:else}
			<button on:click={download} class="btn btn-success w-100">Download</button>
		{/if}
		</div>
	{/if}
	<img style="height:auto;max-width:100%;border:1px solid grey;background:white;" id="imageOverlay" bind:this={imageOverlay} alt="preview" class="{file ? '' : 'd-none'}" />
	<!-- <button on:click={renderLarge} class="btn btn-primary w-100">Shop</button> -->

	<div class="modal" id="quick-text" data-bs-backdrop="static" tabindex="-1" aria-hidden="true"><div class="modal-dialog modal-dialog-scrollable"><div class="modal-content">
		<div class="modal-header">
			Choose Text
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">
			<ul class="list-group list-group-flush">
		 	{#each quickText as qt, i}
				<a href="#" class="list-group-item list-group-item-action" on:click="{ () => setConfig(i) }">{qt.emoji} {qt.text}</a>
			{/each}
			</ul>
		</div>
	</div></div></div>

	<canvas bind:this={canvas2} width={targetWidth} height={targetHeight} style="display:none;" />

	<div class="my-4">
		Questions? hi@EmojiOwl.com
	</div>

</div>
